import { AppRoutes } from '../routing/routes/app-routes.interface';
import { WatchlistSnapshotDetailPageComponent } from './page-detail/watchlist-snapshot-detail-page.component';
import { WatchlistSnapshotDetailPageGuard } from './page-detail/guard/watchlist-snapshot-detail-page.guard';
import { routeTitle } from '../routing/routes/route-title-names.constant';


export const watchlistSnapshotsRoutes: AppRoutes = [
  {
    path: '',
    title: routeTitle.watchlists,
    pathMatch: 'full',
    redirectTo: '/',
  },
  {
    canActivate: [ WatchlistSnapshotDetailPageGuard ],
    path: ':uuid',
    component: WatchlistSnapshotDetailPageComponent,
    title: routeTitle.watchlist
  }
];
